import axios from "axios";

const request = axios.create({
  // baseURL: "/apis",
  timeout: 10000, //请求超时
});
request.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    throw new Error(err);
  }
);

//设置响应拦截
request.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (response.status && response.status !== 200) {
      // 登录超时,重新登录
      if (response.status === 401) {
        // Message.error(res);
        // router.replace("/error");
      }
      return Promise.reject(res || "error");
    } 
    return res;
  },
  (err) => {
    // Message.error(err);
    return Promise.reject(err);
  }
);

export default request;
